/**
 * 🔴 Die E-Mail-Freigabe ist ein abgeleiteter Lesezweig JEDES Versands (Muster verein-FE `src/api/postausgang.ts`,
 * CORE-Plan `2026-09-17/08`).
 *
 * Steht eine Versandkategorie auf „zurückhalten", schreibt der Server die Mail in den Postausgang (`held`). Gelesen
 * wird der an zwei Stellen aus `core-frontend/plugin-email-outbox`: der Hinweisstreifen „N Mails warten auf
 * Freigabe" über `email.outbox.getModes`, die Freigabeseite über `email.outbox.list`. Entwertete die Sende-Mutation
 * nur ihre eigene Domäne, zeigte der Streifen den alten Zähler, bis jemand navigiert
 * (`.claude/rules/entwertung-an-der-mutation.md`).
 *
 * Die Sendewege dieser App mit haltbarer Kategorie: die Einladung (`members.invite`, Kernel-Kategorie `org`) und
 * der Testlauf eines Berichts (`report.runNow`, app-eigene Kategorie `report`).
 */

/**
 * Der schmale Ausschnitt aus `trpc.useUtils()`, den die Entwertung braucht — strukturell, damit Aufrufer ihn ohne
 * Umweg über den vollen Router-Typ übergeben.
 */
export interface PostausgangUtils {
  email: {
    outbox: {
      getModes: { invalidate(): Promise<void> }
      list: { invalidate(): Promise<void> }
    }
  }
}

/**
 * Nach jedem Versand: Streifen (`getModes`) und Freigabeseite (`list`) neu lesen.
 *
 * 🔴 **Unbedingt, nicht nur bei `held`.** Hinge der Aufruf am `held`-Zweig, fiele jeder Weg durch, der `held` nicht
 * als Status meldet.
 */
export async function entwertePostausgang(utils: PostausgangUtils): Promise<void> {
  await utils.email.outbox.getModes.invalidate()
  await utils.email.outbox.list.invalidate()
}
